import { ButtonType, ButtonWidget, FlyoutListMenuWidget } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { ActionStatusIcon, ColumnActionItems, ListMenuStyle, useActionsMenu } from '../TablePlacePage/InlineActionsMenuHelper';
import { detailsDialogActionsMenuButtonStyle } from '../style/ColumnAndFieldDetailsStyles';
import { ColumnDetailsDialogData } from './types/ColumnDetailsDialogData';

const testId =  'column-dialog-actions';

export interface ColumnDetailsActionsMenuProps {
  readonly columnId: string;
  readonly column: ColumnDetailsDialogData;
  readonly enterDescriptionEdit: () => void;
  readonly enterTaggingEdit: () => void;
  readonly canUpdate: boolean;
}

export function ColumnDetailsActionsMenu(props: ColumnDetailsActionsMenuProps): JSX.Element | null {
  const { columnId, column, enterDescriptionEdit, enterTaggingEdit, canUpdate } = props;

  const [buttonEl, setButtonEl] = React.useState<HTMLElement | null>(null);

  const actionsMenu = useActionsMenu({
    columnLuid: column.luid,
    columnName: column.name ?? '',
    columnRemoteType: column.remoteType,
    enterDescriptionEdit: enterDescriptionEdit,
    enterTaggingEdit: enterTaggingEdit
  });

  if (!columnId) {
    return null;
  }

  return (<>
    <ButtonWidget
      buttonType={ButtonType.LowEmphasis}
      title={Messages.Actions()}
      testId={testId + '-button'}
      getContent={(s) => <ActionStatusIcon hover={s.hover || s.active || false} />}
      buttonRef={setButtonEl}
      onClick={() => actionsMenu.setIsMenuShowing(!actionsMenu.isMenuShowing)}
      style={detailsDialogActionsMenuButtonStyle}
      disabled={!canUpdate}
      tabIndex={-1}
    />
    {
      actionsMenu.isMenuShowing && <FlyoutListMenuWidget
        anchorEl={buttonEl}
        menuItemInfos={ColumnActionItems({ columnLuid: column.luid, canUpdate: canUpdate})}
        testId={testId + '-menu'}
        toggleEl={buttonEl}
        menuStyle={ListMenuStyle}
        onSelect={(value: string) => {
          actionsMenu.onSelect(value);
        }}
        requestCloseAll={() => {
          actionsMenu.setIsMenuShowing(false);
        }}
      />}
  </>);
}